import { l } from '../lib/imports'
import { fi32, IFrameInfo } from '../main/frameInfo'
import { common } from '../main/common-sidecar'
import { spriteMap } from '../main/spriteMap-sidecar'

export interface IFrameAnimPart {
  fi: IFrameInfo
  delay?: number
}
export interface IFrameAnimData {
  frames: IFrameAnimPart[]
  delay: number
  loop: boolean
  after: IFrameAnimData | null
}

export interface IFrameAnim {
  data: IFrameAnimData
  frameIdx: number
  delay: number
  playing: boolean
  image: Phaser.GameObjects.Image | null
}

export const create = (
  animData: IFrameAnimData,
  image: Phaser.GameObjects.Image | null = null,
): IFrameAnim => {
  return {
    data: animData,
    frameIdx: 0,
    delay: 0,
    playing: false,
    image,
  }
}

export function play(
  anim: IFrameAnim,
  animData: IFrameAnimData,
  force: boolean = false,
) {
  if (anim.data !== animData || force || !anim.playing) {
    anim.data = animData
    anim.frameIdx = 0
    anim.delay = animData.frames[0].delay || animData.delay
    anim.playing = true
    if (anim.image) {
      spriteMap.setFrame(anim.image, anim.data.frames[anim.frameIdx].fi)
    }
  }
}

export const createFiRow = (i: number, y: number, x: number, w: number) => {
  let fis: IFrameInfo[] = []
  for (let idx = 0; idx < w; idx++) {
    fis.push(fi32(i, y, x + idx))
  }
  return fis
}

export const createAnimData = (fi: IFrameInfo[]) => {
  let frames = l.map(fi, (c) => {
    let fap = {
      fi: c,
    }
    return fap
  })
  let a: IFrameAnimData = {
    delay: 0.5,
    loop: true,
    frames,
    after: null,
  }
  return a
}

export const update = (anim: IFrameAnim, onFrameChange?: () => void) => {
  if (!anim.playing) {
    return
  }
  anim.delay -= common.getUpdateDeltaScaled()
  if (anim.delay <= 0) {
    anim.frameIdx++
    if (anim.frameIdx >= anim.data.frames.length) {
      anim.frameIdx = 0
      if (!anim.data.loop) {
        anim.playing = false
      }
      if (anim.data.after) {
        play(anim, anim.data.after, true)
      }
    }
    anim.delay = anim.data.frames[anim.frameIdx].delay || anim.data.delay
    if (anim.playing) {
      if (anim.image) {
        spriteMap.setFrame(anim.image, anim.data.frames[anim.frameIdx].fi)
      }
      if (onFrameChange) {
        onFrameChange()
      }
    }
  }
}
